const TStrings = {
    SIGNATURE_TAB_DRAW: 'Draw',
    SIGNATURE_TAB_TYPE: 'Type',
    SIGNATURE_TAB_UPLOAD: 'Upload',
    SIGNATURE_TAB_SAVED: 'Saved',
    SIGNATURE_TAB_CLEAR: 'CLEAR',
    SIGNATURE_TYPE_PLACEHOLDER: 'Type your name',
    SIGNATURE_TERMS_TITLE: 'Electronic Signature Agreement',
    SIGNATURE_TERMS_BODY:
        'The parties agree that this agreement may be electronically signed. The parties agree that the electronic signatures appearing on this agreement are the same as handwritten signatures for the purposes of validity, enforceability, and admissibility.',
    SIGNATURE_TERMS_BUTTON: 'Agree',
};
export default TStrings;
